import React from 'react';
import styled from 'styled-components';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import CurrentSearchSkeleton from 'components/domain/currentSearch/CurrentSearch.skeleton';
import { searchFormWrapCss } from 'components/domain/searchControl/SearchControlFormLayout';
import { FdrSearchControlSkeleton } from 'fdr/components/candidate/fdr-search-control/skeleton';

const SearchControlSkeletonWrapper = styled(FdrSearchControlSkeleton)(
  searchFormWrapCss
);

const WishlistSearchControlFormSkeleton: React.FC = () => {
  const { mobile } = useDeviceType();

  return mobile ? (
    <CurrentSearchSkeleton />
  ) : (
    <SearchControlSkeletonWrapper
      height={60}
      maxTabs={2}
      maxInputs={2}
      className="searchControlFormLayoutWrapper"
    />
  );
};

export default WishlistSearchControlFormSkeleton;
